module.exports = __webpack_public_path__ + "media/images/animations/axle_spacing/5-835ccefd7119ddece14713adbf05a88f.png";